import { useQuery } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useReorderEpisodeList(podcastId, data = {}) {
  const { enabled = true, queryKey = ['podcast-reorder-episode', podcastId] } = data;
  const { privateFetch } = useContext(FetchContext);

  const fetchReorderEpisodes = () =>
    privateFetch.get(`/v1/admin/podcast/${podcastId}/episode?mode=reorder`);

  return useQuery(queryKey, fetchReorderEpisodes, {
    enabled: enabled && !!podcastId,
    keepPreviousData: false,
    cacheTime: 0,
    staleTime: 0,
    select: (res) => res?.data?.data || [],
  });
}

export default useReorderEpisodeList;
